function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".bespoken_add_icon_svg__cls-1{fill:#393c51}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "bespoken_add_icon_svg__Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "bespoken_add_icon_svg__Capa_6",
  "data-name": "Capa 6"
}, React.createElement("path", {
  className: "bespoken_add_icon_svg__cls-1",
  d: "M10 20a10 10 0 117.07-17.08A10 10 0 0110 20zm0-18.18a8.18 8.18 0 105.79 2.39A8.16 8.16 0 0010 1.82z"
}), React.createElement("path", {
  className: "bespoken_add_icon_svg__cls-1",
  d: "M10 14a.91.91 0 01-.91-.91V6.86a.91.91 0 011.82 0v6.27A.91.91 0 0110 14z"
}), React.createElement("path", {
  className: "bespoken_add_icon_svg__cls-1",
  d: "M13.13 10.9H6.86a.91.91 0 010-1.82h6.27a.91.91 0 110 1.82z"
})));

var SvgBespokenAddIcon = function SvgBespokenAddIcon(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 19.99 19.99"
  }, props), _ref, _ref2);
};

export default SvgBespokenAddIcon;